import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';

export class WallComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.wallComponent;
    }
}